import { createContext } from 'react';
import { n as noop } from '../../../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const FormStateContext = /*#__PURE__*/createContext({
  stage: 'intro',
  onIntroVisited: noop
});

export { FormStateContext as F };
//# sourceMappingURL=FormStageContext-CEDzLzYf.js.map
